import { BrokerUiModel } from '../ui-models/broker.ui-model';
import { BrokerModel } from '../models/broker.model';

function mapToUI(brokerData: BrokerModel): BrokerUiModel {
  return {
    id: brokerData.id,
    name: brokerData.name,
    contactPersonName: brokerData.contactPersonName,
    contactPersonEmail: brokerData.contactPersonEmail,
    contactPersonPhoneNumber: brokerData.contactPersonPhoneNumber,
    createdAt: brokerData.createdAt,
    updatedAt: brokerData.updatedAt
  };
}

function mapToModel(brokerData: BrokerUiModel): BrokerModel {
  return {
    id: brokerData.id,
    name: brokerData.name,
    contactPersonName: brokerData.contactPersonName,
    contactPersonEmail: brokerData.contactPersonEmail,
    contactPersonPhoneNumber: brokerData.contactPersonPhoneNumber
  };
}

function mapToUIList(brokersList: BrokerModel[]): BrokerUiModel[] {
  return brokersList.map(mapToUI);
}

export default { mapToUI, mapToModel, mapToUIList };
